import { models } from "types/api/viewModels.ts";
import { AcknowledgementPriceFormat } from "types/declarations/enums.ts";
import {
	AcknowledgementPriceFormatListText,
	AcknowledgementPriceFormatNetText,
	AcknowledgementPriceFormatNetWithMultiplierText,
	AcknowledgementPriceFormatVariousText,
	UnavailableDataPlaceholderText
} from "constants/text.ts";

export const getAckPriceFormat = (billTos: models["BillToViewModel"]) => {
	const recipients = billTos?.acknowledgements?.recipients;
	const defaultFormat = billTos.acknowledgements?.defaultPriceFormat;

	const formatMap = {
		[AcknowledgementPriceFormat.LIST]: AcknowledgementPriceFormatListText,
		[AcknowledgementPriceFormat.NET]: AcknowledgementPriceFormatNetText,
		[AcknowledgementPriceFormat.NET_MULTIPLIER]: AcknowledgementPriceFormatNetWithMultiplierText
	};

	// show default price format if there are no email recipients
	if (!recipients?.length) {
		return formatMap[defaultFormat as keyof typeof formatMap] ?? UnavailableDataPlaceholderText;
	}

	// show email recipients price format if all email recipients have the same price format
	for (const [format, text] of Object.entries(formatMap)) {
		if (recipients.every((r) => r.priceFormat === format)) {
			return text;
		}
	}

	// show various text if not all recipients have the same price format
	return AcknowledgementPriceFormatVariousText;
};

export const getAckEmailCount = (billTos: models["BillToViewModel"]) =>
	billTos?.acknowledgements?.recipients?.filter((r) => r.email).length ?? 0;

export const formatBillToDisplay = (billTo: models["BillToViewModel"]) =>
	[billTo?.billToId, billTo?.projectName].filter(Boolean).join(" - ");
